import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Form,Tooltip, Button, Spinner, Alert, Card } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TabPane from 'react-bootstrap/TabPane';
import { newSubProductCreation,resetSubProductCreatiion,imageUploadFailureProcess,imageuploadProcess } from "./subproductAction";
import { newAdultRatesCreation,newHourRatesCreation,newVehicleRatesCreation,newChildRatesCreation,newInfantRatesCreation,newSeasonalRatesCreation ,newPromotionRatesCreation} from "../rates/ratesAction";
import { newItenaryCreation } from "../itenary/itenaryAction";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Datetime from "react-datetime";
import { DefaultEditor } from 'react-simple-wysiwyg';
import { upload } from '@testing-library/user-event/dist/upload';
import UploadService from "../../../api/FileUploadApi2";
import { useNavigate , Link } from 'react-router-dom';
import Swal from 'sweetalert2'
import { getAllProduct } from "../product/productAction";
import { getSinglePaxhealth } from "../paxhealth/paxhealthAction";
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
import { axiosPrivate } from '../../../hooks/axiosPrivate';

import { FaEye, FaArrowAltCircleRight, FaTrash, FaPlus, FaBan, FaArrowLeft} from 'react-icons/fa';
// import { Tooltip } from 'react-tooltip';

const CreateSubProduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const SubProductRef = useRef(null);
  const fileref = useRef('');
  const [productid,setProductid]= useState('');
  const [subproductname,setSubproductname]= useState('');
  const [snackopen4, setSnackOpen4] = useState(false);

  const [perShow,setPerShow] = useState(false);
  const [fixamtShow,setFixamtShow] = useState(false);
  const [dayShow,setDayShow] = useState(false);
  const [timeShow,setTimeShow] = useState(false);

  const [percentage,setPercentage]= useState('');
  const [imagePreviews, setImagePreviews] = useState([]);
  const [fixamt,setFixamt]= useState('');
  const [paxlimit,setPaxlimit]= useState('');
  const [mainimage,setMainImage]= useState('');
  const [timelimit,setTimelimit]= useState('');
  const [isithourly,setIsItHourly]= useState('');
  const [isitvehicle,setIsItVehicle]= useState('');
  const [occres,setOccres]= useState('');
  const [adultper,setAdultper]= useState('');
  const [childper,setChildper]= useState('');
  const [infantper,setInfantper]= useState('');
  const [paxlimitno,setPaxlimitNo]= useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [message, setMessage] = useState([]);
  const [progressInfos, setProgressInfos] = useState([]);



  const [status,setStatus]= useState('');
  const [status2,setStatus2]= useState('');
  const [sfromDate , setSFromDate ] = useState('');
  const [toDate2 , setToDate2 ] = useState('');
  const [discounttype , setDiscounttype ] = useState('');
  const [discounttype2 , setDiscounttype2 ] = useState('');
  const [discount2 , setDiscount2 ] = useState('');
  const [discount , setDiscount ] = useState('');
  const [seasonalremark , setSeasonalremark ] = useState('');
  const [promotionremark , setPromotionremark ] = useState('');
  const [offercode , setOffercode ] = useState('');
  const [toDate3 , setToDate3 ] = useState('');
  const [fromDate , setFromDate ] = useState('');
  const [toDate , setToDate ] = useState('');
  const [fromDate2 , setFromDate2 ] = useState('');
  const [fromAge2, setFromAge2] = useState('');
  const [fromAge, setFromAge] = useState('');
  const [toAge, setToAge] = useState('');
  const [toAge2, setToAge2] = useState('');
  const [errors2, setErrors2] = useState({});
  const [tabHandle, setTabHandle] = useState('adultrate');
  const [tabHandle2, setTabHandle2] = useState('basic');
  const [errors3, setErrors3] = useState({});
  const [fromAgeError, setFromAgeError] = useState('');
  const [toAgeError, setToAgeError] = useState('');

  const [fromDateError, setFromDateError] = useState('');
  const [fromDateError2, setFromDateError2] = useState('');
  const [toDateError, setToDateError] = useState('');
  const [toDateError2, setToDateError2] = useState('');
  const [paxlimitshow, setPaxlimitShow] = useState(false);
  const [timelimitshow, setTimeLimitShow] = useState(false);
  const [minmaxshow, setMinMaxShow] = useState(false);
  const [minmaxshow2, setMinMaxShow2] = useState(false);
  const [occresshow, setOccresShow] = useState(false);
  const [dup, setDup] = useState(true);
  const [dup2, setDup2] = useState(false);


  const [fromAgeError2, setFromAgeError2] = useState('');
  const [toAgeError2, setToAgeError2] = useState('');

  const [alertStatus, setAlertStatus] = useState('');
  const { register, handleSubmit, watch,formState: { errors } } = useForm();
  const { products } = useSelector((state) => state.productList);
  const paxData = useSelector((state) => state.paxList);
  const pxData = JSON.parse(JSON.stringify(paxData.pSDetails));


  const { baseid } = useSelector((state) => state.productratesList);
  const { SubProductId,subproducts2 } = useSelector((state) => state.subproductList);
console.log("SubProductId",SubProductId)
  const { supiscLoading, supcstatus, supcMessage, } = useSelector((state) => state.supplierList);
  const [sections, setSections] = useState([]);
  const [sections2, setSections2] = useState([]);
  const [sections3, setSections3] = useState([]);
  const [sectionsIn, setSectionsIn] = useState([]);
  const [sectionsEx, setSectionsEx] = useState([]);
  const [sections4, setSections4] = useState([]);
  const [adultrate, setAdultrate] = useState([]);
  const [hourrate, setHourrate] = useState([]);
  const [vehiclerate, setVehiclerate] = useState([]);
  const [extraAdultrate, setExtraAdultrate] = useState([]);
  const [childrate, setChildrate] = useState([]);
  const [infantrate, setInfantrate] = useState([]);
  const [seasonal, setSeasonal] = useState([]);
  const [inclusion, setInclusion] = useState([]);
  console.log("inclusion",inclusion)
  const [exclusion, setExclusion] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [terms,setTerms]= useState('');
  const [abouttour,setAboutTour]= useState('');
  const [addinfo,setAddInfo]= useState('');
  const [pickuploc,setPickUpLoc]= useState('');
  const [bdays,setbdays]= useState('');
  const [bhours,setbhours]= useState('');

  const [dailystarttime,setDailystarttime]= useState('');
  const [dailyendtime,setDailyendtime]= useState('');

  const [fromtime,setFromtime]= useState('');
  const [totime,setTotime]= useState('');
  console.log("snnnnnnnn",fromtime)
  console.log("snnnnnnnn",totime)

  const [mintime,setMintime]= useState('');
  const [maxtime,setMaxtime]= useState('');

  const [minpax,setMinpax]= useState('');
  const [maxpax,setMaxpax]= useState('');



  console.log("promotion",promotion)
  console.log("seasonal",seasonal)
  console.log("adultrate",adultrate)
  console.log("childrate", childrate)
  console.log("infantrate", infantrate)


  
  const handleAddSection = () => {
    setSections(prevSections => [...prevSections, { childrate: Array(7).fill('') }]);
  };
  const handleAddSection2 = () => {
    setSections2(prevSections => [...prevSections, { infantrate: Array(7).fill('') }]);
  };


  const handleProductData = (e) => {
    setProductid(e)
    dispatch(getSinglePaxhealth(e))

  }

  const handleClose4 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen4(false);
  };
  const action4 = (
    <React.Fragment>
   
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose4}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );


  console.log("display data",pxData)


  const handleAddSection3 = () => {
    setSections3(prevSections => [...prevSections, { seasonal: Array(7).fill('') }]);
  };


  const handleAddSectionIn = () => {
    setSectionsIn(prevSections => [...prevSections, { inclusion: Array(1).fill('') }]);
  };

  const handleAddSectionEx = () => {
    setSectionsEx(prevSections => [...prevSections, { exclusion: Array(1).fill('') }]);
  };

  const handleAddSection4 = () => {
    setSections4(prevSections => [...prevSections, { promotion: Array(7).fill('') }]);
  };

  const handleRemoveSection = (index) => {
    setSections(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection2 = (index) => {
    setSections2(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection3 = (index) => {
    setSections3(prevSections => prevSections.filter((_, i) => i !== index));
  };


  const handleRemoveSectionIn = (index) => {
    setSectionsIn(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSectionEx = (index) => {
    setSectionsEx(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleRemoveSection4 = (index) => {
    setSections4(prevSections => prevSections.filter((_, i) => i !== index));
  };

  const handleCopyToAll2 = (sectionIndex, index) => {
    const selectedValue = sections[sectionIndex].childrate[index];
  const updatedRates = sections[sectionIndex].childrate.map(() => selectedValue);

  const updatedSections = [...sections];
  updatedSections[sectionIndex].childrate = updatedRates;
  setSections(updatedSections);
  };


  const handleCopyToAll3 = (sectionIndex, index) => {
    const selectedValue = sections2[sectionIndex].infantrate[index];
  const updatedRates = sections2[sectionIndex].infantrate.map(() => selectedValue);

  const updatedSections = [...sections2];
  updatedSections[sectionIndex].infantrate = updatedRates;
  setSections2(updatedSections);
  };

  const handleChildRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections];
    updatedSections[sectionIndex].childrate[index] = value;
    setSections(updatedSections);
    setChildrate(updatedSections)
  };


  const handleInfantRateChange = (sectionIndex, index, value) => {
    const updatedSections = [...sections2];
    updatedSections[sectionIndex].infantrate[index] = value;
    setSections2(updatedSections);
    setInfantrate(updatedSections)
  };
  const handleAdultRateChange = (index, value) => {
    const updatedAdultrate = [...adultrate];
    updatedAdultrate[index] = value;
    setAdultrate(updatedAdultrate);
  };

  const handleHourRateChange = (index, value) => {
    const updatedHourrate = [...hourrate];
    updatedHourrate[index] = value;
    setHourrate(updatedHourrate);
  };


  const handleVehicleRateChange = (index, value) => {
    const updatedVehiclerate = [...vehiclerate];
    updatedVehiclerate[index] = value;
    setVehiclerate(updatedVehiclerate);
  };

  const handleExtraAdultRateChange = (index, value) => {
    const updatedAdultrate = [...extraAdultrate];
    updatedAdultrate[index] = value;
    setExtraAdultrate(updatedAdultrate);
  };

  const renderCommissionFields = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = adultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
          <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            key={index}
            id={`adultrate-${index}`}
            type="number"
            value={adultrate[index] || ''}
            onChange={(e) => handleAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };


  const renderCommissionFieldsHourly = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = hourrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setHourrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
          <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            key={index}
            id={`hourrate-${index}`}
            type="number"
            value={hourrate[index] || ''}
            onChange={(e) => handleHourRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };


  const renderCommissionFieldsVehicle = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll = () => {
      const firstValue = vehiclerate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setVehiclerate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div  style={{display:'flex',marginLeft:'65px'}}>
        {daysOfWeek.map((day, index) => (
          <p>
          {/* <label>{day}</label> */}
          <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            key={index}
            id={`vehiclerate-${index}`}
            type="number"
            value={vehiclerate[index] || ''}
            onChange={(e) => handleVehicleRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </p>
        ))}
       
      </div>
    );
  };



  const renderCommissionFields4 = () => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleCopyToAll4 = () => {
      const firstValue = extraAdultrate[0]; // Get the value of the first field
    
      // Copy the first value to all other fields
      const updatedRates = daysOfWeek.map(() => firstValue);
    
      setExtraAdultrate(updatedRates); // Update the state with the new values
    };
    
    
    
    
    
    return (
      <div>
        {daysOfWeek.map((day, index) => (
          <>
          {/* <label>{day}</label> */}
          <input
            key={index}
            id={`extraAdultrate-${index}`}
            type="number"
            value={extraAdultrate[index] || ''}
            onChange={(e) => handleExtraAdultRateChange(index, e.target.value)}
            placeholder={day}
            style={{width:'100px',marginLeft:'15px',borderRadius:'4px',fontSize:'15px'}}
          />
            {index === 0 && (
       
           <Button variant="secondary" style={{fontSize:'10px',borderRadius:'0px', backgroundColor:'black'}} onClick={handleCopyToAll4}>
           <FaArrowAltCircleRight />
           </Button>
     
          )}
          
          </>
        ))}
       
      </div>
    );
  };

  const renderCommissionFields2 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const handleFromAgeChange = (e) => {
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.fromAge === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError('From Age is already selected in another section');
      } else {
        setFromAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange = (e) => {
      const { value } = e.target;
      const isToAgeAlreadySelected = sections.some((section, index) => {
        return index !== sectionIndex && section.toAge === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError('To Age is already selected in another section');
      } else {
        setToAgeError('');
        setSections((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
      <div style={{ display: 'flex',marginLeft:'120px' }}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex].fromAge}
          onChange={handleFromAgeChange}
          onBlur={validateForm}
        >
          <option value="">Choose..</option>
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </Form.Select>
        {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
        <Form.Select
          style={{ width: '268px', marginLeft: '15px' }}
          required
          value={sections[sectionIndex].toAge}
          onChange={handleToAgeChange}
          onBlur={validateForm}
          disabled={!sections[sectionIndex].fromAge}
        >
          <option value="">Choose..</option>
          {[...Array(13).keys()].slice(parseInt(sections[sectionIndex].fromAge) + 1).map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </Form.Select>
        {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
      </div>
      <br />
      <div  style={{display:'flex',marginLeft:'71px'}}>
      {daysOfWeek.map((day, index) => (
        <div key={index} style={{ display: 'inline' }}>
          <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>
          <input
            type="number"
            value={sections[sectionIndex].childrate[index] || ''}
            onChange={(e) => handleChildRateChange(sectionIndex, index, e.target.value)}
            placeholder={day}
            style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
          />
          {index === 0 && (
            <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor:'black' }} onClick={() => handleCopyToAll2(sectionIndex, index)}>
              <FaArrowAltCircleRight />
            </Button>
          )}
          </p>
        </div>
        
      ))}
      </div>
    </div>
    );
  };



  const renderCommissionFields6 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange2 = (e) => {
      const { value } = e.target;
    
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.toDate3 && value <= section.toDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isFromDateOverlap) {
        setFromDateError2('From Date overlaps with another section');
      } else {
        setFromDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate3 = value;
          return updatedSections;
        });
      }
      // Update promotion data
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          fromDate3: value,
        };
        return updatedPromotion;
      });
    };
    
    const handleToDateChange2 = (e) => {
      const { value } = e.target;
    
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections4.some((section, index) => {
        if (index !== sectionIndex && section.fromDate3 && value >= section.fromDate3) {
          return section.fromDate3 <= value && value <= section.toDate3;
        }
        return false;
      });
    
      if (isToDateOverlap) {
        setToDateError2('To Date overlaps with another section');
      } else {
        setToDateError2('');
        setSections4((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate3 = value;
          return updatedSections;
        });
      }

        // Update promotion data
        setPromotion((prevPromotion) => {
          const updatedPromotion = [...prevPromotion];
          updatedPromotion[sectionIndex] = {
            ...updatedPromotion[sectionIndex],
            toDate3: value,
          };
          return updatedPromotion;
        });
    };

    const handlediscounttypeChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discounttype2: value,
        };
        return updatedPromotion;
      });
    };



    const handlediscountChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          discount2: value,
        };
        return updatedPromotion;
      });
    };


    const handleoffercodeChange = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          offercode: value,
        };
        return updatedPromotion;
      });
    };

    const handleremarkChange2 = (e) => {
      const { value } = e.target;
  
      setPromotion((prevPromotion) => {
        const updatedPromotion = [...prevPromotion];
        updatedPromotion[sectionIndex] = {
          ...updatedPromotion[sectionIndex],
          promotionremark: value,
        };
        return updatedPromotion;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'121px' }}>
          <Form.Label style={{ fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            min={new Date().toISOString().split('T')[0]}

            value={sections4[sectionIndex].fromDate3}
            onChange={handleFromDateChange2}
          />
          &nbsp;
          &nbsp;
          
  
          <Form.Label style={{ fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections4[sectionIndex].toDate3}
            onChange={handleToDateChange2}
            disabled={!sections4[sectionIndex].fromDate3}
            min={sections4[sectionIndex].fromDate3}
          />
          {toDateError2 && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError2}</p>}
        </div>
        <br />
        {fromDateError2 && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError2}</p>}
        <br />
        <div style={{display:'flex',marginLeft:'71px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label>

        <Form.Select required name="discounttype2" value={sections4[sectionIndex].discounttype2} onChange={handlediscounttypeChange2}  style={{ width: '231px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              &nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="number"  name="discount2" required="true" autoComplete='off' placeholder="Enter Discount" value={sections4[sectionIndex].discount2} onChange={handlediscountChange2} />&nbsp;
    <Form.Control  style={{ width: '231px',height:'36px' }} type="text"  name="offercode" required="true" autoComplete='off' placeholder="Enter Offer Code" value={sections4[sectionIndex].offercode} onChange={handleoffercodeChange} />

&nbsp;
   
        </div>
        <br />
        <Row className="mb-3" style={{marginLeft:"0px"}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  
   <DefaultEditor rows="5" style={{backgroundColor:'white'}}   name="promotionremark" value={promotion[sectionIndex]?.promotionremark || ''} onChange={handleremarkChange2}
    />

</Form.Group>


</Row>    
        <br />
        {/* Rest of the code */}
      </div>
    );
  };




  const renderCommissionFields5 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  
    const handleFromDateChange = (e) => {
      const { value } = e.target;
  
      // Check if the selected from date overlaps with any existing section's date range
      const isFromDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.toDate2 && value <= section.toDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isFromDateOverlap) {
        setFromDateError('From Date overlaps with another section');
      } else {
        setFromDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          fromDate2: value,
        };
        return updatedSeasonal;
      });
    };
  
    const handleToDateChange = (e) => {
      const { value } = e.target;
  
      // Check if the selected to date overlaps with any existing section's date range
      const isToDateOverlap = sections3.some((section, index) => {
        if (index !== sectionIndex && section.fromDate2 && value >= section.fromDate2) {
          return section.fromDate2 <= value && value <= section.toDate2;
        }
        return false;
      });
  
      if (isToDateOverlap) {
        setToDateError('To Date overlaps with another section');
      } else {
        setToDateError('');
        setSections3((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toDate2 = value;
          return updatedSections;
        });
      }
  
      // Update seasonal data
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          toDate2: value,
        };
        return updatedSeasonal;
      });
    };
    


    const handlediscounttypeChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discounttype: value,
        };
        return updatedSeasonal;
      });
    };


    const handlediscountChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          discount: value,
        };
        return updatedSeasonal;
      });
    };


    const handleremarkChange = (e) => {
      const { value } = e.target;
  
      setSeasonal((prevSeasonal) => {
        const updatedSeasonal = [...prevSeasonal];
        updatedSeasonal[sectionIndex] = {
          ...updatedSeasonal[sectionIndex],
          seasonalremark: value,
        };
        return updatedSeasonal;
      });
    };
    
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'71px' }}>
          <Form.Label style={{ marginLeft: '63px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            From Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            min={new Date().toISOString().split('T')[0]}

            value={sections3[sectionIndex].fromDate2}
            onChange={handleFromDateChange}
          />
         
  
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>
            To Date
          </Form.Label>
          <Form.Control
            type="date"
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections3[sectionIndex].toDate2}
            onChange={handleToDateChange}
            disabled={!sections3[sectionIndex].fromDate2}
            min={sections3[sectionIndex].fromDate2}
          />
          {toDateError && <p className="text-danger" style={{ fontSize: '10px' }}>{toDateError}</p>}
        </div>
        <br />
        {fromDateError && <p className="text-danger" style={{ fontSize: '12px',fontWeight:'500',textAlign:'center' }}>{fromDateError}</p>}
        <br />
        <div style={{display:'flex',marginLeft:'91px'}}>
        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Seasonal Rate</Form.Label>

        <Form.Select required name="discounttype" value={sections3[sectionIndex].discounttype} onChange={handlediscounttypeChange}  style={{ width: '270px',height:'36px', marginLeft: '15px' }}>
                
                <option value="">Choose..</option>
                <option value="Percentage">Percentage</option>
                <option value="Fixed">Fixed</option>
              </Form.Select>


              {/* &nbsp;        <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Discount</Form.Label> */}

    <Form.Control name="discount"  style={{ width: '270px',height:'36px', marginLeft: '73px'  }} type="number" value={sections3[sectionIndex].discount} onChange={handlediscountChange}    required="true" autoComplete='off' placeholder="Enter AddOn Rate"  />

&nbsp;
    
        </div>
        <br />
     
        <Row className="mb-3" style={{marginLeft:'0px'}}>
  <Form.Group as={Col} controlId="formGridProductdescription">
  {/* <Form.Label>Description</Form.Label> */}
  
   <DefaultEditor rows="5"  name="seasonalremark"  style={{backgroundColor:'white'}} value={seasonal[sectionIndex]?.seasonalremark || ''} onChange={handleremarkChange}  
    />

</Form.Group>


</Row>        <br />
       
      </div>
    );
  };





  const renderCommissionFieldsIn = (sectionIndex) => {
    const handleInclusionChange = (e) => {
      const { value } = e.target;
  
      setInclusion((prevInclusion) => {
        const updatedInclusion = [...prevInclusion];
        updatedInclusion[sectionIndex] = {
          ...updatedInclusion[sectionIndex],
          inclusion: value,
        };
        return updatedInclusion;
      });
    };
  
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex', marginLeft: '22px' }}>
          <Form.Control
            name="inclusion"
            style={{ width: '870px', height: '36px', marginLeft: '73px' }}
            type="text"
            value={inclusion[sectionIndex]?.inclusion || ''}
            onChange={handleInclusionChange}
            required
            autoComplete='off'
            placeholder="Enter Inclusion Details"
          />
        </div>
      </div>
    );
  };
  





  
  const renderCommissionFieldsEx = (sectionIndex) => {
    const handleexclusionChange = (e) => {
      const { value } = e.target;

      setExclusion((prevExclusion) => {
        const updatedExclusion = [...prevExclusion];
        updatedExclusion[sectionIndex] = {
          ...updatedExclusion[sectionIndex],
          exclusion: value,
        };
        return updatedExclusion;
      });
    };

    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex', marginLeft: '22px' }}>
          <Form.Control 
          name="exclusion"
          style={{ width: '870px', 
          height: '32px', 
          marginLeft: '73px' }} 
          type="text" 
          value={exclusion[sectionIndex]?.exclusion || ''}
          onChange={handleexclusionChange} 
          required="true" 
          autoComplete='off' 
          placeholder="Enter Exclusion Details" />


        </div>

      </div>
    );
  };
  
  
  




  const renderCommissionFields3 = (sectionIndex) => {
    const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    const handleFromAgeChange2 = (e) => {
      const { value } = e.target;
      const isFromAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.fromAge2 === value;
      });
      if (isFromAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setFromAgeError2('From Age is already selected in another section');
      } else {
        setFromAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].fromAge2 = value;
          return updatedSections;
        });
      }
    };
  
    const handleToAgeChange2 = (e) => {
      const { value } = e.target;
      const isToAgeAlreadySelected = sections2.some((section, index) => {
        return index !== sectionIndex && section.toAge === value;
      });
      if (isToAgeAlreadySelected) {
        // Display an error message or handle the validation error as needed
        // For example, you can set an error state variable and display the error message
        setToAgeError2('To Age is already selected in another section');
      } else {
        setToAgeError2('');
        setSections2((prevSections) => {
          const updatedSections = [...prevSections];
          updatedSections[sectionIndex].toAge2 = value;
          return updatedSections;
        });
      }
    };
 
    return (
      <div key={sectionIndex}>
        <div style={{ display: 'flex',marginLeft:'120px' }}>
          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>From Age</Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections2[sectionIndex].fromAge2}
            onChange={handleFromAgeChange2}
            onBlur={validateForm2}
          >
            <option value="">Choose..</option>
            <option value="0">0</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            
          </Form.Select>
          {/* {errors2.fromAge && <p className="text-danger" style={{ fontSize: '10px' }}>{errors2.fromAge}</p>} */}

          <Form.Label style={{ marginLeft: '15px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>To Age</Form.Label>
          <Form.Select
            style={{ width: '268px', marginLeft: '15px' }}
            required
            value={sections2[sectionIndex].toAge2}
            onChange={handleToAgeChange2}
            onBlur={validateForm2}
            disabled={!sections2[sectionIndex].fromAge2}
          >
            <option value="">Choose..</option>
            {[...Array(7).keys()].slice(parseInt(sections2[sectionIndex].fromAge2) + 1).map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </Form.Select>
          {/* &nbsp;{errors2.toAge && <p className="text-danger" style={{ fontSize: '13px' }}>{errors2.toAge}*</p>} */}
        </div>
        <br />
        <div  style={{display:'flex',marginLeft:'71px'}}>
        {daysOfWeek.map((day, index) => (
          <div key={index} style={{ display: 'inline' }}>
             <p>
            <p style={{fontSize:'15px',marginLeft:'45px',color:'black'}}>{day}</p>

            <input
              type="number"
              value={sections2[sectionIndex].infantrate[index] || ''}
              onChange={(e) => handleInfantRateChange(sectionIndex, index, e.target.value)}
              placeholder={day}
              style={{ width: '100px', marginLeft: '15px', borderRadius: '4px', fontSize: '15px' }}
            />
            {index === 0 && (
              <Button variant="secondary" style={{ fontSize: '10px', borderRadius: '0px', backgroundColor: 'black' }} onClick={() => handleCopyToAll3(sectionIndex, index)}>
                <FaArrowAltCircleRight />
              </Button>
            )}
                 </p>
          </div>
        ))}
      </div>
      </div>
    );
  };

  

  const validateToDate = (toDate) => {
    if (!fromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateToDate2 = (stoDate) => {
    if (!sfromDate) {
      return 'Please select a From Date first';
    }
  
    const fromDateObj = new Date(sfromDate);
    const toDateObj = new Date(stoDate);
  
    if (toDateObj < fromDateObj) {
      return 'To Date must be later than or equal to From Date';
    }
  
    return true; // Return true if the validation passes
  };

  const validateForm = () => {
    const newErrors = {};

    if (fromAge === '') {
      newErrors.fromAge = 'From Age is required';
    }

    if (toAge === '') {
      newErrors.toAge = 'To Age is required';
    } else if (parseInt(toAge) <= parseInt(fromAge)) {
      newErrors.toAge = 'To Age must be greater than From Age';
    }

    setErrors2(newErrors);
  };

  const validateForm2 = () => {
    const newErrors = {};

    if (fromAge2 === '') {
      newErrors.fromAge2 = 'From Age is required';
    }

    if (toAge2 === '') {
      newErrors.toAge2 = 'To Age is required';
    } else if (parseInt(toAge2) <= parseInt(fromAge2)) {
      newErrors.toAge2 = 'To Age must be greater than From Age';
    }

    setErrors3(newErrors);
  };


  

  const handleFromAgeChange2 = (e) => {
    setFromAge2(e.target.value);
    setToAge2('');
  };
  
const handlePaxlimit = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name == "paxlimit" && checked){
    setPaxlimit(1);
    setPaxlimitShow(true)
  }else {
    setPaxlimit(0)
    setPaxlimitShow(false);
  }
}


const handleMainImage = (e) => {
  const checked = e.target.checked;

  if (e.target.name === "mainimage" && checked) {
    const payload = {
      subproductid: SubProductId,
      mainimage: 1
    };

    axiosPrivate.post("/excursionsubproductimage/createsubproductsimages", payload)
      .then(response => {
        // Handle the response if needed
        setMainImage(1);
        setTabHandle2('rate');
      })
      .catch(error => {
        // Handle the error if the request fails
      });
  } else {
    setMainImage(0);
  }
};



const handleTimelimit = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "timelimit" && checked){
    setTimelimit(1);
    setTimeLimitShow(true)
  }else {
    setTimelimit(0)
    setTimeLimitShow(false);
  }
}


const handleIsItHourly = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "isithourly" && checked){
    setIsItHourly(1);
    setMinMaxShow(true);
    setIsItVehicle(0);
    setMinMaxShow2(false);
    setMinpax('');
    setMaxpax('');
  }else {
    setIsItHourly(0);
    setMinMaxShow(false);
  }
}



const handleIsItVehicle = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "isitvehicle" && checked){
    setIsItVehicle(1);
    setMinMaxShow2(true);
    setIsItHourly(0);
    setMinMaxShow(false);
    setMintime('');
    setMaxtime('');
  }else {
    setIsItVehicle(0);
    setMinMaxShow2(false);
  }
}


const handleOccRes = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "occres" && checked){
    setOccres(1);
    setOccresShow(true)
  }else {
    setOccres(0)
    setOccresShow(false);
  }
}


const handleAdult = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "saap" && checked){
    setAdultper(1);
  }else {
    setAdultper(0)
  }
}


const handleChild = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "sacp" && checked){
    setChildper(1);
  }else {
    setChildper(0)
  }
}

const handleInfant = (e) =>{
  const checked = e.target.checked;

  
  if(e.target.name === "saip" && checked){
    setInfantper(1);
  }else {
    setInfantper(0)
  }
}


  const handleCommission = (e) =>{

    if(e == "Percentage"){
      setPerShow(true);
      setFixamtShow(false)
    }else if(e === "Fixamt"){
      setFixamtShow(true)
      setPerShow(false);
    }
    }
  
  useEffect(() => {
    dispatch(getAllProduct());
    
  }, []);
  const handleOnSubmit = (e) => {
    e.preventDefault();
    if(productid && subproductname && status){
        const newSubProductCreation1 = {
            productid,
            subproductname,
            paxlimit,
            paxlimitno,
            occres,
            adultper,
            childper,
            infantper,
            isithourly,
            isitvehicle,
            bdays,
            bhours,
            fromtime,
            totime,
            mintime,
            maxtime,
            minpax,
            maxpax,
            status,

        };
        dispatch(
            newSubProductCreation(newSubProductCreation1)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Sub Product Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
  
          // navigate('/subproductList');
         
            setTabHandle2('images')
        
        setProductid('');
        setSubproductname('');
        setPaxlimitNo('');
        setStatus('');
        e.target.reset();
    }
 
  };


  const handleOnSubmit1 = (e) => {
    e.preventDefault();

        const newAdultRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            adultrate,

        };
        dispatch(
            newAdultRatesCreation(newAdultRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };



  const handleOnSubmithour = (e) => {
    e.preventDefault();

        const newHourRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            hourrate,

        };
        dispatch(
            newHourRatesCreation(newHourRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };

  const handleOnSubmitvehicle = (e) => {
    e.preventDefault();

        const newVehicleRateCreation = {
            SubProductId,
            fromDate,
            toDate,
            vehiclerate,

        };
        dispatch(
            newVehicleRatesCreation(newVehicleRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
 
 
  };


  
  const handleOnSubmit2 = (e) => {
    e.preventDefault();
    if(sections.length > 0){

        const newChildRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge,
            toAge,
            childRates: childrate,

        };
        dispatch(
            newChildRatesCreation(newChildRateCreation)
        )
        setTabHandle('infantrate');

        Swal.fire({
            title: 'Success!',
            text: 'Child Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
        }else{
          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle('infantrate');
                  Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })

        }
 
 
  };


    
  const handleOnSubmit3 = (e) => {
    e.preventDefault();

    if(sections2.length > 0){

        const newInfantRateCreation = {
            baseid,
            fromDate,
            toDate,
            fromAge2,
            toAge2,
            infantRates: infantrate,

        };
        dispatch(
            newInfantRatesCreation(newInfantRateCreation)
        )
        setTabHandle('seasonalrate')

        Swal.fire({
            title: 'Success!',
            text: 'Infant Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })

        }else{

          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle('seasonalrate')
                  Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })


        }
 
 
  };

  const handleOnSubmitItenary = (e) => {
    e.preventDefault();

        const newItenaryCreation1 = {
            SubProductId,
            dailystarttime,
            dailyendtime,
            abouttour,
            terms,
            pickuploc,
            addinfo,
            inclusion: inclusion,
            exclusion: exclusion,
            status2

        };
        dispatch(
            newItenaryCreation(newItenaryCreation1)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Itinerary Details Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          });
          navigate('/subproductList');
 
 
  };


  

  const handleOnSubmit4 = (e) => {
    e.preventDefault();

    if(sections3.length > 0){

        const newSeasonalRateCreation = {
            baseid,
           
            seasonalRates: seasonal,

        };
        dispatch(
          newSeasonalRatesCreation(newSeasonalRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Seasonal Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })
          setTabHandle('promotionalrate')

        }else{

          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle('promotionalrate')
                  Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })


        }
 
 
  };


  const handleOnSubmit5 = (e) => {
    e.preventDefault();

    if(sections4.length > 0){

        const newPromotionRateCreation = {
            baseid,
           
            promotionRates: promotion,

        };
        dispatch(
          newPromotionRatesCreation(newPromotionRateCreation)
        )
        Swal.fire({
            title: 'Success!',
            text: 'Promotion Rate Added Successfully',
            icon: 'success',
            confirmButtonText: 'Okay'
          })

          
          setTabHandle2('itenary')

        }else{
          Swal.fire({
            title: 'Are you sure want to skip the section?',
            showDenyButton: true,
            icon:'error',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            denyButtonText: 'No',
            customClass: {
              actions: 'my-actions',
              cancelButton: 'order-1 right-gap',
              confirmButton: 'order-2',
              denyButton: 'order-3',
            }
          }).then((result) => {
            if (result.isConfirmed) {
              
              setTabHandle2('itenary')
              Swal.fire('You have Skipped the Section!', '', 'success');
           
            }
        
             else if (result.isDenied) {
              Swal.fire('Changes are not saved', 'Your Data is safe', 'info')
            }
          })


        }
       
 
 
  };
  const uploadImages = (e) => {
    setDup(true);
    setDup2(true);

      e.preventDefault();
      if (selectedFiles.length === 0) {
        // show an error message
        let failure_result = {
          message: "Please Select an image file (Webp)",
        };
        Swal.fire("Image Upload Failed!!","Please Select an image file (Webp).",'error')
        dispatch(imageUploadFailureProcess(failure_result));
        setMessage([]);
        setProgressInfos([]);
        return;
      }
    
      setMessage([]);
    
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        
        if (file.size > 1024 * 1024) {
          // Show an error message for files larger than 1MB
          let failure_result = {
            message: "Selected image is too large. Please select an image under 1MB.",
          };
          Swal.fire("Image Upload Failed!!","Selected image is too large. Please select an image under 1MB.",'error')


          dispatch(imageUploadFailureProcess(failure_result));
          setMessage([]);
          setProgressInfos([]);
          return;
        }
        
        upload(i, SubProductId, file);
      }
      
      // Reset the file input value
      fileref.current.value = '';
    
      setSnackOpen4(true);
    };

  // const uploadImages =  (e) => {
  //   setDup(true);
  //   e.preventDefault();
  //   if (selectedFiles.length==0) {
  //     // show an error message
  //     let failure_result= {
  //       message: "Please Select a image file(Webp)",
       
  //     }
  //     dispatch(imageUploadFailureProcess(failure_result));
  //     setMessage([]);
  //     setProgressInfos([]);
  //     return;
  //   }

     
  //   setMessage([]);

   
  //   for (let i = 0; i < selectedFiles.length; i++) {
    
  //     upload(i,SubProductId, selectedFiles[i]);
  //   }
  //   fileref.current.value='';

  //   setSnackOpen4(true);

  // };
  const upload = (idx,subproduct_id, file) => {

      
    let _progressInfos = [...progressInfos];

 
    return UploadService.upload(file,subproduct_id, (event) => {
      _progressInfos[idx].percentage = Math.round(
        (100 * event.loaded) / event.total
      );
      setProgressInfos(_progressInfos);
    })
      .then(() => {
        setMessage((prevMessage) => [
          ...prevMessage,
          "Image Uploaded Successfully: " + file.name,
        ]);
     
        let success_result= {
          message: "Image Uploaded Successfully",
         
        }
        dispatch(imageuploadProcess(success_result));
      })
      .catch(() => {
        _progressInfos[idx].percentage = 0;
        setProgressInfos({ val: _progressInfos });

        setMessage((prevMessage) => [
          ...prevMessage,
          "Could not upload the image: " + file.name,
        ]);
      });

      
  };

  
  const selectFiles = (event) => {
    setDup(false);
    let images = [];
    let selectedFiles = [];
  
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      if (file.type === 'image/webp') {
        images.push(URL.createObjectURL(file));
        selectedFiles.push(file);
      }
    }
  
    setSelectedFiles(selectedFiles);
    setImagePreviews(images);
    setProgressInfos([]);
    setMessage([]);
  };
  useEffect(() => {
      

     
    let objectLength = Object.keys(selectedFiles).length;
    let _progressInfos = [];
    

if(objectLength>0)
{
     for (let i = 0; i < selectedFiles.length; i++) {
      _progressInfos.push({ percentage: 0, fileName: selectedFiles[i].name });
     }
   }   
 
    setProgressInfos([]);
      setProgressInfos([...progressInfos, ..._progressInfos]);

               
   }, [selectedFiles]);
  

  const canSave = Boolean (productid) && Boolean(subproductname) && Boolean(status)
  const canSave2 = Boolean (dailyendtime) && Boolean(dailystarttime) && Boolean(abouttour) && Boolean(terms) && Boolean(status2)
//console.log(curstatus);
//console.log('msg');
//console.log(curmessage);
  //console.log(passwordError.confirmPassword);

  //hourly
  const handleBefore = (e) => {

    if (e === "Day") {
      setDayShow(true);
      setTimeShow(false)
    } else if (e === "Hour") {
      setTimeShow(true)
      setDayShow(false);
    }
  }

  
  return (
    <>
      {/* <Container className="my-4 mx-4 container-xl ">
      <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>

          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Create New Sub Product</h4></Card.Header>
          <Card.Body>
          <Row>
              <Col>
      
              <Link to="/subproductList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
              <br />
          
              </Col>
            </Row> */}
            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Create New Sub Product</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/subproductList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Snackbar
              open={snackopen4}
              autoHideDuration={6000}
              onClose={handleClose4}
              variant="success"
              message="Uploaded Successfully"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Position the Snackbar top right

              action={action4}
            >
              <MuiAlert
                elevation={6}
                variant="filled"
                onClose={handleClose4}
                severity="success" // Set the severity to "success" for the green color
                sx={{ width: '100%' }}
              >
                Uploaded Successfully

              </MuiAlert>
            </Snackbar>

                <Tabs
     
      activeKey={tabHandle2}
      id="justify-tab-example"
      className="mb-3"
      justify
    >
          
            <Tab eventKey="basic" title="Basic Details">
    

            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit(e))}> {/* handleOnSubmit() */}

<Row className="mb-3">
<Form.Group as={Col} controlId="formGridServiceType">
<Form.Label>Product Name <span className='text-danger'>*</span></Form.Label>
<Form.Select  name="productid" required="true" onChange={(e) => handleProductData(e.target.value)}>
<option  value="" >Choose</option>
{products.map((products,index) =>

<option key={products.id} value={products.id} >{products.product_name}</option>
)}
</Form.Select>
</Form.Group>
 
  <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Sub Product Name</Form.Label>
    <Form.Control type="text" ref={SubProductRef}  name="subproductname" required="true" autoComplete='off' placeholder="Enter Sub Product Name" {...register("subproductname", { required: true, mixLength: 3 })}  onChange={(e) => setSubproductname(e.target.value)}/>
    {errors.mobile && <p className='text-danger'> Sub Product Name required</p>}
  </Form.Group>
  </Row>
 
  <Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="paxlimit"  label="Is it a private tour ?"  {...register("paxlimit", { required: true, mixLength: 3 })}  onChange={(e) => handlePaxlimit(e)} />
 
</Form.Group> 
{paxlimitshow === true && <><Form.Group as={Col} controlId="formGridMobile">
<Form.Label>Pax Limit</Form.Label>
    <Form.Control type="number" ref={SubProductRef}  name="paxlimitno" required="true" autoComplete='off' placeholder="Enter the pax limit" {...register("paxlimitno", { required: true, mixLength: 3 })}  onChange={(e) => setPaxlimitNo(e.target.value)}/>
  </Form.Group></>}

</Row>
<Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="isithourly" checked={isithourly == 1 ? true : false}  label="Is it a hourly rates ?"  {...register("isithourly", { required: true, mixLength: 3 })}  onChange={(e) => handleIsItHourly(e)} />
 
</Form.Group> 

{minmaxshow === true && <>

<Form.Group as={Col} controlId="formGridDialyStartTime">
<Form.Label>Minimum Time <span className='text-danger'></span> </Form.Label>
<Form.Control type="number" ref={SubProductRef}  name="mintime" required="true" value={mintime} autoComplete='off' placeholder="Enter the minimum time"  onChange={(e) => setMintime(e.target.value)} />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridDialyEndTime">
  <Form.Label>Maximum Time <span className='text-danger'></span> </Form.Label>
  <Form.Control type="number" ref={SubProductRef}  name="maxtime" required="true" value={maxtime} autoComplete='off' placeholder="Enter the maximum time" onChange={(e) => setMaxtime(e.target.value)} />
 
  </Form.Group>
</> }

</Row>


<Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="isitvehicle" checked={isitvehicle == 1 ? true : false}  label="Is it a vehicle rates ?"  {...register("isitvehicle", { required: true, mixLength: 3 })}  onChange={(e) => handleIsItVehicle(e)} />
 
</Form.Group> 

{minmaxshow2 === true && <>

<Form.Group as={Col} controlId="formGridDialyStartTime">
<Form.Label>Minimum Pax <span className='text-danger'></span> </Form.Label>
<Form.Control type="number" ref={SubProductRef}  name="minpax" required="true" value={minpax} autoComplete='off' placeholder="Enter the minimum pax"   onChange={(e) => setMinpax(e.target.value)} />
  </Form.Group>

  <Form.Group as={Col} controlId="formGridDialyEndTime">
  <Form.Label>Maximum Pax <span className='text-danger'></span> </Form.Label>
  <Form.Control type="number" ref={SubProductRef}  name="maxpax" required="true" value={maxpax} autoComplete='off' placeholder="Enter the maximum pax"  onChange={(e) => setMaxpax(e.target.value)} />
 
  </Form.Group>
</> }

</Row>



<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductName">
    <Form.Label> Booking cut off rule <span className='text-danger'></span></Form.Label>
    <Form.Select required name="before" {...register("before" , { required: true })} onChange={(e) => handleBefore(e.target.value)}>
          
          <option value="">Choose..</option>
          <option value="Day">Day</option>
          <option value="Hour">Hour</option>
        </Form.Select>  </Form.Group>
 {dayShow === true && <> <Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Before Days<span className='text-danger'></span></Form.Label>
    <Form.Control type="number" min="0" ref={SubProductRef}  name="bdays" required="true" autoComplete='off' placeholder="Enter The Number of Days" {...register("bdays", { required: true, mixLength: 3 })}  onChange={(e) => setbdays(e.target.value)}/>
  </Form.Group></>}
 
{timeShow === true && <><Form.Group as={Col} controlId="formGridMobile">
    <Form.Label>Before Hours <span className='text-danger'></span></Form.Label>
    <Datetime initialViewMode="time" name="bhours" {...register("bhours", { required: true, mixLength: 3 })} updateOnView="time" dateFormat={false} timeFormat="HH:mm" onChange={(e) => setbhours(e)} />
  </Form.Group></>}
  </Row>


  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="timelimit"  label="Allowed time slot"  {...register("timelimit", { required: true, mixLength: 3 })}  onChange={(e) => handleTimelimit(e)} />
 
</Form.Group> 
{timelimitshow === true && <>

  <Form.Group as={Col} controlId="formGridDialyStartTime">
  <Form.Label>Time Slot(From) <span className='text-danger'></span> </Form.Label>
  <Datetime initialViewMode="time" name="fromtime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A" selected={fromtime} onChange={fromtime => setFromtime(fromtime)} />
    </Form.Group>

    <Form.Group as={Col} controlId="formGridDialyEndTime">
    <Form.Label>Time Slot(To) <span className='text-danger'></span> </Form.Label>
    <Datetime initialViewMode="time" name="totime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A"  selected={totime} onChange={totime => setTotime(totime)} />
   
    </Form.Group>
</> }
 
  </Row>

<Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="occres"  label="Occupancy Restrictions ?"  {...register("occres", { required: true, mixLength: 3 })}  onChange={(e) => handleOccRes(e)} />
 
</Form.Group> 
{occresshow === true && <>
  <Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="sacp" style={{fontSize:'12px'}} disabled={pxData?.child_permission === 0 ? 1 : 0}  label="Are Children Not Allowed?"  {...register("sacp", { required: true, mixLength: 3 })}  onChange={(e) => handleChild(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridIstricombo2">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="saip" style={{fontSize:'12px'}} disabled={pxData?.infant_permission === 0 ? 1 : 0}  label="Are Infants Not Allowed?"  {...register("saip", { required: true, mixLength: 3 })}  onChange={(e) => handleInfant(e)} />
 
</Form.Group> 
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="saap" style={{fontSize:'12px'}} disabled={pxData?.adult_permission === 0 ? 1 : 0} label="Are Adults Not Allowed?"  {...register("saap", { required: true, mixLength: 3 })}  onChange={(e) => handleAdult(e)} />
 
</Form.Group> 


</>}

</Row>


  <Row className="mb-3">
 
  <Form.Group as={Col} controlId="formGridStatus">
    <Form.Label>Status</Form.Label>
    <Form.Select required name="status" value={status} onChange={(e) => setStatus(e.target.value)}>
      
      <option value="">Choose..</option>
      <option value="1">Enable</option>
      <option value="0">Disable</option>
    </Form.Select>
    {errors.status && <p className='text-danger'>Status required</p>}
  </Form.Group>

</Row>

<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" className='align-middle' disabled={!canSave}>
<FontAwesomeIcon icon={faRightToBracket} /> Submit
</Button>
</div>
{supiscLoading && (<Spinner variant='info' animation='border' />)}

</Form>
    </Tab>
    <Tab eventKey="images" title="Images & Videos">

<p style={{color:'#bb0e0e',marginLeft:'25px'}}>Note: Image Format Should be in Webp</p>

<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(uploadImages(e))}>
<div className="form-group multi-preview">
{/* {(this.fileArray || []).map(url => (
                        <img src={url} alt="..." />
                    ))} */}
</div>

<div className="form-group">
<input type="file" className="form-control" onChange={(e) => selectFiles(e)}  multiple accept="image/webp" ref= {fileref} />
{console.log("testidimage",SubProductId)}
<input type="hidden" name="subproductid" id="subproductid" value={SubProductId}/>
</div>
<br />
 
<Row className="mb-3">
<Form.Group as={Col} controlId="formGridIsdummy">
  
  <Form.Check type="checkbox" ref={SubProductRef}  name="mainimage"  label="Same As Main Product ?"  disabled={dup2} {...register("mainimage", { required: true, mixLength: 3 })}  onChange={(e) => handleMainImage(e)} />
 
</Form.Group> 
</Row>
<Button type="submit" className="btn btn-danger btn-block" disabled={dup}>Upload</Button>&nbsp;&nbsp;<Button  className="btn btn-success btn-block" onClick={()=>setTabHandle2('rate')}  >Next</Button>
</Form>
{progressInfos &&
  progressInfos?.map((progressInfo, index) => (
    <div className="mb-2" key={index}>
      <span>{progressInfo?.fileName}</span>
      <div className="progress">
        <div
          className="progress-bar progress-bar-info"
          role="progressbar"
          aria-valuenow={progressInfo?.percentage}
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: progressInfo?.percentage + "%" }}
        >
          {progressInfo?.percentage}%
        </div>
      </div>
    </div>
  ))}  

{message?.length > 0 && (
  <div className="alert alert-secondary" role="alert">
    <ul>
      {message.map((item, i) => {
        return <li key={i}>{item}</li>;
      })}
    </ul>
  </div>
)}
      </Tab> 

           
              <Tab eventKey="rate" title="Rate Details">




                <hr />
      
                <Tabs
                  // defaultActiveKey='adultrate'
                  activeKey={tabHandle}
                  id="justify-tab-example"
                  className="mb-3"
                  justify

                >

      {isithourly === 1 ?  
                    <Tab eventKey="adultrate" title="Hourly Rates">



                      <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmithour(e))}> {/* handleOnSubmit() */}

                        <Card style={{ backgroundColor: '#1c355ea3', width: '100%' }}>
                          <Row className="mb-3" style={{ padding: '10px' }}>
                            <Form.Group as={Col} controlId="formGridServiceType">
                              <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="fromDate"
                                required
                                min={new Date().toISOString().split('T')[0]}

                                autoComplete="off"
                                placeholder="Enter From Date"
                                {...register('fromDate', { required: true })}
                                onChange={(e) => { setFromDate(e.target.value); setToDate(''); }}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridMobile">
                              <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="toDate"
                                required
                                value={toDate}
                                autoComplete="off"
                                placeholder="Enter To Date"
                                {...register('toDate', { required: true, validate: validateToDate })}
                                min={fromDate}
                                disabled={!fromDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                              {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
                            </Form.Group>
                          </Row>

                          <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Hourly Rates</h6>

                          <hr style={{ marginTop: '5px', color: 'white' }} />


                          {renderCommissionFieldsHourly()}
                          <br />
                          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

                          <br />
                          <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1} onClick={() => setTabHandle('seasonalrate')} style={{ width: '100px', float: 'right', backgroundColor: '#1c355e', color: 'white', marginRight: '5px', fontSize: '10px' }}><FaArrowAltCircleRight />&nbsp;Next </Button></div>
                          <br />

                        </Card> </Form>




                    </Tab>:''}




                    {isitvehicle === 1 ?  
                    <Tab eventKey="adultrate" title="Vehicle Rates">



                      <Form className=" mx-4 my-2" component="form" noValidate autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitvehicle(e))}> {/* handleOnSubmit() */}

                        <Card style={{ backgroundColor: '#1c355ea3', width: '100%' }}>
                          <Row className="mb-3" style={{ padding: '10px' }}>
                            <Form.Group as={Col} controlId="formGridServiceType">
                              <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="fromDate"
                                required
                                min={new Date().toISOString().split('T')[0]}

                                autoComplete="off"
                                placeholder="Enter From Date"
                                {...register('fromDate', { required: true })}
                                onChange={(e) => { setFromDate(e.target.value); setToDate(''); }}
                              />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridMobile">
                              <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
                              <Form.Control
                                type="date"
                                name="toDate"
                                required
                                value={toDate}
                                autoComplete="off"
                                placeholder="Enter To Date"
                                {...register('toDate', { required: true, validate: validateToDate })}
                                min={fromDate}
                                disabled={!fromDate}
                                onChange={(e) => setToDate(e.target.value)}
                              />
                              {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
                            </Form.Group>
                          </Row>

                          <h6 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Bahnschrift Condensed', color: 'black' }}>Vehicle Rates</h6>

                          <hr style={{ marginTop: '5px', color: 'white' }} />


                          {renderCommissionFieldsVehicle()}
                          <br />
                          {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

                          <br />
                          <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1} onClick={() => setTabHandle('seasonalrate')} style={{ width: '100px', float: 'right', backgroundColor: '#1c355e', color: 'white', marginRight: '5px', fontSize: '10px' }}><FaArrowAltCircleRight />&nbsp;Next </Button></div>
                          <br />

                        </Card> </Form>




                    </Tab>:''}
{isithourly !== 1 && isitvehicle !== 1 ?  
            <Tab eventKey="adultrate" title="Adult Rates">
    

            {adultper === 1 || pxData?.adult_permission === 0 ? 
<>              <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}>
<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
            <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          min={new Date().toISOString().split('T')[0]}

          autoComplete="off"
          placeholder="Enter From Date"
          {...register('fromDate', { required: true })}
          onChange={(e) => {setFromDate(e.target.value);setToDate('')}}
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          autoComplete="off"
          value={toDate}

          placeholder="Enter To Date"
          {...register('toDate', { required: true, validate: validateToDate })}
          min={fromDate}
          disabled={!fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>
    <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1}  onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
<br />
      </Card>
      </Form>
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Adults Are Not Permitted.</p>

  
     <br /></>
  :<> 
  <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit1(e))}> {/* handleOnSubmit() */}

                <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
            <Row className="mb-3" style={{padding:'10px'}}>
      <Form.Group as={Col} controlId="formGridServiceType">
        <Form.Label>From Date <span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="fromDate"
          required
          min={new Date().toISOString().split('T')[0]}

          autoComplete="off"
          placeholder="Enter From Date"
          {...register('fromDate', { required: true })}
          onChange={(e) => {setFromDate(e.target.value);setToDate('');}}
        />
      </Form.Group>

      <Form.Group as={Col} controlId="formGridMobile">
        <Form.Label>To Date<span className='text-danger'>*</span></Form.Label>
        <Form.Control
          type="date"
          name="toDate"
          required
          value={toDate}
          autoComplete="off"
          placeholder="Enter To Date"
          {...register('toDate', { required: true, validate: validateToDate })}
          min={fromDate}
          disabled={!fromDate}
          onChange={(e) => setToDate(e.target.value)}
        />
        {errors.toDate && <p className='text-danger'>{errors.toDate.message}</p>}
      </Form.Group>
    </Row>

    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Adult Rates</h6>
      
      <hr style={{marginTop:'5px',color:'white'}} />
     

      {renderCommissionFields()}
    <br />
      {/* <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     <div><Button variant="" type='submit' disabled={fromDate && toDate ? 0 : 1}   onClick={()=>setTabHandle('childrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />

    </Card> </Form></> }
         
   

         
    </Tab>
    : ''}
    {isithourly !== 1 && isitvehicle !== 1  ?  

    <Tab eventKey="childrate" title="Child Rates">

    
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit2(e))}> {/* handleOnSubmit() */}
    {childper === 1 || pxData?.child_permission === 0 ? <> <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Childs Are Not Permitted.</p>
              
              
            <br />
     <div><Button variant=""  onClick={()=>setTabHandle('infantrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
              </Card></>:<>   <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Child Rates</h6>
      
 
    <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} disabled={childper} onClick={handleAddSection}><FaPlus/>&nbsp;Add </Button></div>
{sections.map((section, index) => (
        <div key={index}>
         <hr style={{marginTop:'5px',color:'white'}} />
          {/* Render your section-specific fields here */}
          {renderCommissionFields2(index)}
          <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection(index)}><FaTrash  /></Button>
        </div>
      ))}
      <br />
      <hr style={{marginTop:'5px',color:'white'}} />

      

      <br />
      {/* <div><Button variant=""  type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     
     <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />

    </Card></>}
 
  </Form>
</Tab>
: ''}
{isithourly !== 1 && isitvehicle !== 1  ?  
<Tab eventKey="infantrate" title="Infant Rates">
  
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit3(e))}> {/* handleOnSubmit() */}
{infantper === 1 || pxData?.infant_permission === 0 ? <> <Card  style={{backgroundColor:''}}>
              <br />
              <p style={{textAlign:'center',color:'red'}}><FaBan />&nbsp;Infants Are Not Permitted.</p>
              
              
            <br />
     <div><Button variant=""  onClick={()=>setTabHandle('seasonalrate')} style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
              </Card></>:<> <Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
    <h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Infant Rates</h6>
    <div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} disabled={infantper} onClick={handleAddSection2}><FaPlus/>&nbsp;Add </Button></div>



     

{sections2.map((section, index) => (
        <div key={index}>
                <hr style={{marginTop:'5px',color:'white'}} />
 
          {/* Render your section-specific fields here */}
          {renderCommissionFields3(index)}
          <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection2(index)}><FaTrash  /></Button>
        </div>
      ))}
      <br />
      <hr style={{marginTop:'5px',color:'white'}} />
      

      <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

     <br />
     
     <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
     <br />
    </Card></>}
   
  </Form>



</Tab>
: ''}
<Tab eventKey="seasonalrate" title="Seasonal Supplementary">
    
<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit4(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Seasonal Supplementary</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection3}><FaPlus/>&nbsp;Add </Button></div>



 

{sections3.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields5(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection3(index)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  
  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}


 <br />
 
 <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
 <br />
</Card>
</Form>
</Tab>

<Tab eventKey="promotionalrate" title="Promotion Discount">
    

<Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmit5(e))}> {/* handleOnSubmit() */}

<Card  style={{backgroundColor:'#1c355ea3',width:'100%'}}>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Promotion Discount</h6>
<div><Button variant="" style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSection4}><FaPlus/>&nbsp;Add </Button></div>



 

{sections4.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {/* Render your section-specific fields here */}
      {renderCommissionFields6(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',color:'red'}}   onClick={() => handleRemoveSection4(index)}><FaTrash  /></Button>
    </div>
  ))}
  <br />
  <hr style={{marginTop:'5px',color:'white'}} />
  

  <br />
      {/* <div><Button variant="" type='submit'  style={{width:'100px' ,float:'right',backgroundColor:'#d1af2b',color:'white',marginRight:'5px',fontSize:'10px'}}><FaPlus/>&nbsp;Save </Button></div> */}

 <br />
 
 <div><Button variant="" type='submit' style={{width:'100px' ,float:'right',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}}><FaArrowAltCircleRight/>&nbsp;Next </Button></div>
 <br />
</Card>
</Form>
</Tab>

           
   

    </Tabs>

    

</Tab>


<Tab eventKey="itenary" title="Itinerary Details">
    

    <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={e => handleSubmit(handleOnSubmitItenary(e))}> {/* handleOnSubmit() */}
    <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridDialyStartTime">
  <Form.Label>Daily Start Time <span className='text-danger'>*</span> </Form.Label>
  <Datetime initialViewMode="time" name="dailystarttime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A" selected={dailystarttime} onChange={dailystarttime => setDailystarttime(dailystarttime)} />
    </Form.Group>

    <Form.Group as={Col} controlId="formGridDialyEndTime">
    <Form.Label>Daily End Time<span className='text-danger'>*</span> </Form.Label>
    <Datetime initialViewMode="time" name="dailyendime" updateOnView="time" dateFormat={false} timeFormat="HH:mm A"  selected={dailyendtime} onChange={dailyendtime => setDailyendtime(dailyendtime)} />
   
    </Form.Group>
  </Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>About Tour<span className='text-danger'>*</span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={abouttour}  name="abouttour" {...register("abouttour", { required: true, mixLength: 3 })}  onChange={(e) => setAboutTour(e.target.value)}
    />

</Form.Group>


</Row>

<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Additional Info<span className='text-danger'></span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={addinfo}  name="addinfo" {...register("addinfo", { required: true, mixLength: 3 })}  onChange={(e) => setAddInfo(e.target.value)}
    />

</Form.Group>
</Row>

<Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Pick Up Location<span className='text-danger'></span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={pickuploc}  name="pickuploc" {...register("pickuploc", { required: true, mixLength: 3 })}  onChange={(e) => setPickUpLoc(e.target.value)}
    />

</Form.Group>


</Row>
  <Row className="mb-3">
  <Form.Group as={Col} controlId="formGridProductdescription">
  <Form.Label>Terms & Conditions<span className='text-danger'>*</span></Form.Label>
  
   <DefaultEditor rows="5"  ref={SubProductRef} value={terms}  name="terms" {...register("terms", { required: true, mixLength: 3 })}  onChange={(e) => setTerms(e.target.value)}
    />

</Form.Group>


</Row>

<Card>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Service Inclusions<span className='text-danger'>*</span></h6>

<Row className='mb-3'>
 

  <div  style={{padding:'10px',marginLeft:'5px'}}><Button variant="" style={{width:'100px' ,float:'',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSectionIn}><FaPlus/>&nbsp;Add </Button></div>
{sectionsIn.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {renderCommissionFieldsIn(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',marginLeft:'',color:'red'}}   onClick={() => handleRemoveSectionIn(index)}><FaTrash  /></Button>
    </div>
  ))}

</Row>
</Card>
<br />
<Card>
<h6 style={{textAlign:'center',marginTop:'10px',fontFamily:'Bahnschrift Condensed',color:'black'}}>Service Exclusions<span className='text-danger'>*</span></h6>

<Row className='mb-3'>

<div style={{padding:'10px',marginLeft:'5px'}}><Button variant="" style={{width:'100px' ,float:'',backgroundColor:'#1c355e',color:'white',marginRight:'5px',fontSize:'10px'}} onClick={handleAddSectionEx}><FaPlus/>&nbsp;Add </Button></div>
{sectionsEx.map((section, index) => (
    <div key={index}>
            <hr style={{marginTop:'5px',color:'white'}} />

      {renderCommissionFieldsEx(index)}
      <Button variant="" style={{fontSize:'15px',float:'right',marginLeft:'',color:'red'}}   onClick={() => handleRemoveSectionEx(index)}><FaTrash  /></Button>
    </div>
  ))}

</Row>
</Card>

<Row className="mb-3">

<Form.Group as={Col} controlId="formGridStatus">
<Form.Label>Status<span className='text-danger'>*</span></Form.Label>
<Form.Select required name="status2" value={status2} onChange={(e) => setStatus2(e.target.value)}>

<option value="">Choose..</option>
<option value="1">Enable</option>
<option value="0">Disable</option>
</Form.Select>
{errors.status2 && <p className='text-danger'>Status required</p>}
</Form.Group>

</Row>

<div class="d-grid  col-2 mx-auto">
<Button variant="primary" type="submit" className='align-middle' disabled={!canSave2}>
<FontAwesomeIcon icon={faRightToBracket} /> Submit
</Button>
</div>
{supiscLoading && (<Spinner variant='info' animation='border' />)}

</Form>
</Tab>


    </Tabs>
    </div>
    </div>
    </div>
    </>
  );
}

export default CreateSubProduct;